// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-gatsby-theme-mdx-deck-src-templates-deck-js": () => import("./../../../node_modules/gatsby-theme-mdx-deck/src/templates/deck.js" /* webpackChunkName: "component---node-modules-gatsby-theme-mdx-deck-src-templates-deck-js" */),
  "component---node-modules-gatsby-theme-mdx-deck-src-templates-decks-js": () => import("./../../../node_modules/gatsby-theme-mdx-deck/src/templates/decks.js" /* webpackChunkName: "component---node-modules-gatsby-theme-mdx-deck-src-templates-decks-js" */)
}

